var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plaid-security-info"},_vm._l((_vm.itemList),function(item,index){return _c('div',{key:index,staticClass:"plaid-security-info__item"},[_c('img',{staticClass:"plaid-security-info__item-image",attrs:{"src":item.imgSrc,"alt":""}}),_c('div',{staticClass:"plaid-security-info__item-text"},[_vm._v(" "+_vm._s(item.text)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }